export class HealthDisplay {
	constructor(current, total, player) {
		this.current = Number.parseInt(current, 10);
		this.total = total;
		this.player = player;
	}

	setHealth(current) {
		let updatedHealth = Number.parseInt(current, 10);
		if(updatedHealth === this.current) {
			return;
		}
		this.current = updatedHealth;
	}
}